function fn_comp_service() {
    var $fn = $(".comp_service");

    if($fn.length){
        $fn.find("#service_datepicker").loadDatepicker();


        $(document).on('change','select[data-service-type-select]', function() {

            var selectedType = $(this).val();
            if(!selectedType || !selectedType.length) {
                return;
            }

            $('[data-calendar]').show();

            $.ajax({
                method: 'post',
                url: $(this).attr('data-ajax-link'),
                data: {
                    serviceType: selectedType
                },
                dataType: 'json',
                success: function (payload) {
                    if (payload) {
                        if (payload.snippets) {
                            for (var i in payload.snippets) {
                                $("#" + i).replaceWith(payload.snippets[i]);
                            }
                        }
                    }
                    //$frm.parent('.part_dialog').prev('[data-dialog-close]').click();
                    $('.part_datepicker').loadDatepicker();
                }
            });

        });

    }
}